import { CoreStringValueBuilderPart } from "./CoreModels";

export interface CoreGoogleDeviceExportConfiguration {
    id: string
    moduleId: string
    organizationalUnitSettings: CoreGoogleDeviceOrganizationalUnitSettings
}

export interface CoreGoogleDeviceOrganizationalUnitSettings {
    organizationalUnitSource: GoogleDeviceOrganizationalUnitSource
    enableCreateOrganizationalUnit : boolean
    stringValueBuilderParts: CoreStringValueBuilderPart[]
    deniedOUPath: CoreOrganizationalUnitPath[]
    ignoredOUPath: CoreOrganizationalUnitPath[]
}

export interface CoreOrganizationalUnitPath {
    path: string
    operator: GoogleDeviceOUOperator
}

export enum GoogleDeviceOrganizationalUnitSource {
    None = 0,
    /// <summary>
    /// Use same OU as last recent user.
    /// </summary>
    RecentUser = 1,
    /// <summary>
    /// User same OU as the device SchoolAdmin connection.
    /// </summary>
    SchoolAdminUser = 2,
    /// <summary>
    /// Use StringValueBuilder to use parts to build OU.Class, School stages, form of education, Primary school, StudentSchoolYear, Constant, StudentSchoolYear
    /// </summary>
    ValueBuilder = 3
}

export enum GoogleDeviceOUOperator {
    None = 0,
    StartsWith = 1,
    Equals = 2,
}